import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: '100vh',
    },
    welcome: {
      fontSize: 80,
    },
    fullName: {
      fontSize: 40,
    },
  }),
);

export default useStyles;
